<!-- <div class="gap-2 searchInput d-flex">
    <img src="../../../../assets/icons_svg/search.svg" alt="">
    <input type="text" pInputText placeholder="Search by Participant Name" [(ngModel)]="searchQuery"
      (ngModelChange)="handleSearch($event)" />
  </div>  -->

<div id="st-common-search-bar-searchinput-1" class="stupa-search-bar d-flex align-items-center h-100" [style.maxWidth]="searchbarMaxWidth"
  *ngIf="screenWidth > 1024">
  <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none"
    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>

  <input #searchInput type="text" pInputText [placeholder]="searchPlaceholder | translate" [(ngModel)]="searchQuery"
    *ngIf="screenWidth > 1024 || inputExpanded" (input)="handleSearch($event)" />
  <ng-container *ngTemplateOutlet="searchSuffixTpl"></ng-container>
</div>
<!-- <div class="searchInput d-flex align-items-center h-100" [ngClass]="{
    'mobile_screen gap-1': screenWidth < 1024,
    'gap-2': screenWidth > 1024
  }" [style.background-color]="bg_color"> -->
<div id="st-common-search-bar-sch-mobile-toolbar" class="sch-mobile-toolbar sch-mobile-toolbar--inline-search w-100 d-flex justify-content-end"
  *ngIf="screenWidth <= 1024">
  <div id="st-common-search-bar-sch-mobile-inline-search" class="sch-mobile-inline-search" [ngClass]="{ 'collapsed': isCollapsedInlineSearch }"
    (click)="onInlineSearchShellClick($event)">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M10.759 11.4615L6.57177 7.27432C6.23843 7.54953 5.8551 7.76491 5.42177 7.92047C4.98843 8.07602 4.54014 8.1538 4.0769 8.1538C2.93746 8.1538 1.97311 7.75928 1.18387 6.97023C0.394622 6.18119 0 5.21709 0 4.07795C0 2.93879 0.394522 1.97434 1.18357 1.1846C1.97261 0.394867 2.93671 0 4.07587 0C5.21501 0 6.17946 0.394623 6.9692 1.18387C7.75894 1.97311 8.15382 2.93746 8.15382 4.0769C8.15382 4.55297 8.0739 5.00767 7.91407 5.441C7.75423 5.87433 7.54098 6.25126 7.27432 6.57177L11.4615 10.759L10.759 11.4615ZM4.0769 7.15383C4.93588 7.15383 5.66344 6.85576 6.2596 6.2596C6.85575 5.66345 7.15383 4.93588 7.15383 4.0769C7.15383 3.21792 6.85575 2.49036 6.2596 1.8942C5.66344 1.29805 4.93588 0.999967 4.0769 0.999967C3.21792 0.999967 2.49036 1.29805 1.8942 1.8942C1.29806 2.49036 0.999983 3.21792 0.999983 4.0769C0.999983 4.93588 1.29806 5.66345 1.8942 6.2596C2.49036 6.85576 3.21792 7.15383 4.0769 7.15383Z"
        fill="#767676" />
    </svg>
    <div id="st-common-search-bar-sch-mobile-inline-search-fields" class="sch-mobile-inline-search-fields">
      <input #mobileInlineSearchInput type="text" class="sch-mobile-inline-search-input" autocomplete="off"
        inputmode="search"
        enterkeyhint="search" [(ngModel)]="searchQuery" (input)="handleSearch($event)"
        [placeholder]="searchPlaceholder | translate" [tabIndex]="isCollapsedInlineSearch ? -1 : 0" />
      <button type="button" class="sch-mobile-inline-search-clear" (click)="onClearInlineSearchClick($event)"
        [attr.aria-label]="'close' | translate" [tabIndex]="isCollapsedInlineSearch ? -1 : 0">
        <svg class="sch-mobile-inline-search-clear-icon" width="8" height="8" viewBox="0 0 24 24" fill="none"
          aria-hidden="true">
          <path stroke="currentColor" stroke-width="2.5" stroke-linecap="round" d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
      <ng-container *ngTemplateOutlet="searchSuffixTpl"></ng-container>
    </div>
  </div>
</div>

<!-- One projection slot shared by both layouts (only one layout exists at a time). -->
<ng-template #searchSuffixTpl>
  <span class="search-suffix"><ng-content select="[searchSuffix]"></ng-content></span>
</ng-template>
